
import { Component, Prop, Vue } from "vue-property-decorator";
import { midiDispatcher } from "src/modules/midi/MidiDispatcher";
import * as Audio from "src/modules/audio";

@Component
export default class TeacherChatBubble extends Vue {
  @Prop({ required: true }) readonly message!: any;
  @Prop({ required: true }) readonly visible!: boolean;
  @Prop({ required: true }) readonly chatBottom!: number;
  @Prop({ required: false, default: false }) readonly isInPlayer!: boolean;

  mounted() {
    if (this.message.timeout) {
      setTimeout(() => {
        this.$emit('dismiss');
      }, this.message.timeout);
    }
  }

  handleAction(action) {
    const performanceTestValid = Audio.musicTranscriptionController.state.performanceTestValid;
    let counter = parseInt(localStorage.getItem('toursWithoutAudioCapture'), 10) || 0;
    if ((action.label === 'Recommencer' || action.label === 'Augmenter le tempo' || action.label === 'Essayer plus lentement') &&
      Audio.musicTranscriptionController.state.workerState !== 'ready' && !midiDispatcher.state.isActive && !localStorage.getItem('StopAskingForAudioCapture') && performanceTestValid !== 'notMade' && performanceTestValid !== 'reported') {

      counter++;
      localStorage.setItem('toursWithoutAudioCapture', counter.toString());

      if (counter === 1 || counter === 4 || counter === 9) {
        setTimeout(() => {
          this.displayActivateAudioCaptureSuggestion(action, counter === 5);
        }, 10);
      }
      else {
        action.handler();
      }
    }
    else {
      action.handler();
    }
  }

  displayActivateAudioCaptureSuggestion(action, dontDisplayAgainButton = false) {
    this.$emit('new-suggestion', {
      message: "Vous n'avez pas activé le mode écoute, souhaitez-vous l'activer ?",
      actions: [{
        label: 'Activer',
        color: 'primary',
        icon: 'mdi-ear-hearing',
        handler: () => {
          this.$root.$emit('activate_audio_capture');
          this.executeActionWhenListeningModeReady(action)
        },
      },
      dontDisplayAgainButton ?
        {
          label: 'Ne plus me demander',
          color: 'black',
          handler: () => {
            localStorage.setItem('StopAskingForAudioCapture', 'true');
            this.$emit('dismiss');
            action.handler();
          }
        }
        :
        {
          label: 'Non merci',
          color: 'black',
          handler: () => {
            this.$emit('dismiss');
            action.handler();
          }
        }
      ]
    });
  }

  get chatMessageStyle() {
    return {
      bottom: (this.chatBottom + 50) + 'px',
      right: '110px',
      maxWidth: this.$q.screen.lt.md ? '70%' : '50%',
    };
  }

  openConversation() {
    this.$emit('open-conversation');
  }

  executeActionWhenListeningModeReady(action, tries = 0) {
    if (this.isListeningNotes) {
      action.handler()
    }
    else if (tries <= 5) {
      setTimeout(() => this.executeActionWhenListeningModeReady(action, tries + 1), 500);
    }
  }

  get isListeningNotes() {
    return Audio.musicTranscriptionController.state.workerState === 'ready';
  }
}
